import React from "react";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import ScreenVideoIntroLoader from '../elements/loaders/ScreenVideoIntroLoader';

let resizeTid = null;
const resizeDelay = .3;

class TopVideoBlock extends React.PureComponent {
    getWindowWidth = () => {
        return window.innerWidth
    };
    getWindowHeight = () => {
        return window.innerHeight
    };
    state = {
        windowHeight: this.getWindowHeight(),
        windowWidth: this.getWindowWidth(),

        vRef: null,
        isVideoLoaded: false,

        videoWidth: 0,
        videoHeight: 0,
    };
    componentDidMount() {
        window.addEventListener('resize', this.resizeHandler);
    }
    componentWillUnmount() {
        clearTimeout(resizeTid);

        window.removeEventListener('resize', this.resizeHandler);
    }
    resizeHandler = (e) => {
        clearTimeout(resizeTid);

        resizeTid = setTimeout(() => {
            this.setState({
                windowHeight: this.getWindowHeight(),
                windowWidth: this.getWindowWidth(),
            });
        }, resizeDelay * 1000);
    };
    videoOnLoad = (e) => {
        let { videoIntroComplete } = this.props;

        this.setState({
            videoWidth: e.target.videoWidth,
            videoHeight: e.target.videoHeight,
            isVideoLoaded: true,
        });

        videoIntroComplete();

        console.log('video loaded and playing')
        // for testing
        /*setTimeout(() => {
            videoIntroComplete();
        }, 2000);*/
    };

    downloadClickHandler = () => {
        let { history } = this.props;

        history.push('/free-trial');
    };

    getVideoStyles = () => {
        let { windowHeight, windowWidth, videoWidth, videoHeight, isVideoLoaded } = this.state;

        let videoStyles = {};

        if (isVideoLoaded) {
            let scale, calculatedVideoWidth, calculatedVideoHeight;

            let videoScale = videoWidth / videoHeight;
            let windowScale = windowWidth / windowHeight;

            if (videoScale > windowScale) {
                scale = windowHeight / videoHeight;
                calculatedVideoWidth = videoWidth * scale;
                calculatedVideoHeight = windowHeight;
            } else {
                scale = videoHeight / windowHeight;
                calculatedVideoWidth = windowWidth;
                calculatedVideoHeight = windowHeight * scale;
            }

            videoStyles = {
                height: calculatedVideoHeight,
                width: calculatedVideoWidth,
                scrollLeft: (windowWidth - calculatedVideoWidth) / 2,
                scrollTop: (windowHeight - calculatedVideoHeight) / 2,
            };
        }

        return videoStyles;
    };

    videoRef = (video) => {
        let { vRef } = this.state;

        if (!video || vRef) {
            return false;
        }

        video.addEventListener( "play", this.videoOnLoad, false );
        video.addEventListener('canplaythrough', () => {
            video.play();
        });

        video.autoplay = true;
        video.load();

        this.setState({
            vRef: video,
        })
    };

    render() {
        let { isVideoLoaded } = this.state;
        let {
            isVideoIntro,
            isVideoIntroComplete,
            videoSrc,
            children,
        } = this.props;

        return (
            <div className={'top-video-block-wrapper'}>
                {isVideoIntro ? <ScreenVideoIntroLoader isScreenLoader={true} isVideoIntroComplete={isVideoIntroComplete}/> : false}

                <div className={`top-video-block loaded ${isVideoIntro ? ' video-intro' : ''} video-intro-complete`}>
                    <video
                        playsInline={true}
                        ref={this.videoRef}
                        style={this.getVideoStyles()}
                        preload={'auto'}
                        autoPlay={true}
                        muted={true}
                        loop={true}
                    >
                        <source src={videoSrc} type="video/mp4"/>
                    </video>

                    {children}
                </div>
            </div>
        );
    }
}

TopVideoBlock.propTypes = {
    children: PropTypes.node,
    videoSrc: PropTypes.node.isRequired,
    isVideoIntro: PropTypes.bool.isRequired,
    isVideoIntroComplete: PropTypes.bool.isRequired,
    videoIntroComplete: PropTypes.func.isRequired,
};

export default withRouter(TopVideoBlock);
